import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';

@Component({
  selector: 'cnc-auth-change-password',
  templateUrl: './auth-change-password.component.html',
  styleUrls: ['./auth-change-password.component.scss'],
})
export class AuthChangePasswordComponent implements OnInit {
  hide :boolean = true;
  loading :boolean = false;
  submitted :boolean = false;
  pageTitle :string = this.translate.instant('GENERAL.CHANGE_PASSWORD');
  formData :UntypedFormGroup;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private authService :AuthService,
    private toastr :ToastrService,
    private translate :TranslateService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      new_password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  handleSubmit(e :SubmitEvent) {
    e.preventDefault();

    this.#submit();
  }

  #submit() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FORM_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FORM_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    this.hide = true;
    this.loading = true;
    const data = this.formData.value;
    this.authService.updatePassword(data).subscribe(
      (resp :any) => {
        Swal.fire({
          title: this.translate.instant('MESSAGES.SAVE_SUCCESS.TITLE'),
          text: resp.message,
          type: 'success',
          confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
        }).then((_) => {
          this.loading = false;
          this.activeModal.close();
        });
      },
      (errorResp) => {
        Swal.fire({
          title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
          text: errorResp.error.message,
          type: 'error',
          confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
        }).then((_) => {
          this.loading = false;
        });
      },
    );
  }
}
